
    // IMPORTS
    import { defineComponent, PropType, ref } from 'vue';
    import loaderGuard from './loader-guard.vue'

    export default defineComponent({
        name: 'lazy-render',

        components: {
            loaderGuard
        },

        props: {
            size: {
                type: String as PropType<string>, // Accept percentage like '50%' or pixel values like '64px'
                required: false,
                default: () => '64px', // Default to pixel-based size for backward compatibility
                validator: (value: string) => {
                    // Regular expression to check if the value is a valid number, 'px', or '%'
                    const regex = /^(\d+(\.\d+)?)(px|%)?$/
                    return regex.test(value)
                }
            }        },

        setup() {
            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const allowRender = ref(false)

            const publicData = { allowRender }

            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/
            setTimeout(() => allowRender.value = true, 10)

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData }
        }
    });
